import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const FooterContainer = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.background.paper,
	borderTop: `1px solid ${theme.palette.divider}`,
	padding: theme.spacing(4, 0),
	marginTop: 'auto',
}));

const FooterLink = styled(Link)(({ theme }) => ({
	color: theme.palette.text.secondary,
	textDecoration: 'none',
	'&:hover': {
		color: theme.palette.primary.main,
		textDecoration: 'none',
	},
}));

const FooterCookieButton = styled(Link)(({ theme }) => ({
	color: theme.palette.text.secondary,
	textDecoration: 'none',
	'&:hover': {
		color: theme.palette.primary.main,
		textDecoration: 'none',
	},
}));

// Extend the Window interface to include CookieScript
declare global {
	interface Window {
		CookieScript?: {
			instance?: {
				show: () => void;
			};
		};
	}
}

const Footer: React.FC = () => {
	const currentYear = new Date().getFullYear();

	return (
		<FooterContainer>
			<Container maxWidth='lg'>
				<Grid container spacing={4}>
					{/* Company Info */}
					<Grid item>
						<Typography variant='h6' gutterBottom color='primary' sx={{ pr: 6 }}>
							DeepAR
						</Typography>
					</Grid>

					{/* Quick Links */}
					<Grid item xs={12} md={2}>
						<Typography variant='subtitle2' gutterBottom>
							Product
						</Typography>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
							<FooterLink href='/pricing'>Pricing</FooterLink>
							<FooterLink href='/downloads'>Downloads</FooterLink>
							<FooterLink href='/demo-projects'>Demo Projects</FooterLink>
						</Box>
					</Grid>

					{/* Support Links */}
					<Grid item xs={12} md={2}>
						<Typography variant='subtitle2' gutterBottom>
							Support
						</Typography>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
							<FooterLink href='/customer-agreement'>Customer Agreement</FooterLink>
							<FooterLink href='/privacy'>Privacy Policy</FooterLink>
							<FooterLink href='/terms'>Terms of Service</FooterLink>
							<FooterCookieButton
								href='#'
								onClick={(e: React.MouseEvent) => {
									e.preventDefault();
									if (typeof window.CookieScript !== 'undefined' && window.CookieScript.instance) {
										window.CookieScript.instance.show();
									}
								}}
								sx={{ cursor: 'pointer' }}
							>
								Manage Cookies
							</FooterCookieButton>
						</Box>
					</Grid>
				</Grid>

				<Divider sx={{ my: 3 }} />

				<Box sx={{ textAlign: 'center' }}>
					<Typography variant='body2' color='text.secondary'>
						© I Love Ice Cream Ltd.
					</Typography>
				</Box>
			</Container>
		</FooterContainer>
	);
};

export default Footer;
